import { motion, MotionProps } from "framer-motion";
import { HTMLAttributes } from "react";

/**
 * `motion.div` with its DOM props typed here: framer-motion 6 types `motion.<tag>` through
 * React's `ReactHTML` type, which React 19's types lack, so there it accepts no DOM props.
 * `motion.div` is a cached `motion("div")`, so both are the same component at runtime.
 */
export const MotionDiv =
  motion<Omit<HTMLAttributes<HTMLDivElement>, keyof MotionProps>>("div");
